// extracted by css-extract-rspack-plugin
export default {"imageCardGridItem":"IndexSection-module__imageCardGridItem__qX0vf","imageCardColumn":"IndexSection-module__imageCardColumn__mU63H"};